import { FunctionalLogger } from '../Logger';

const namespace = 'bbk_';
const logger = FunctionalLogger('client');

function getSetting(name, defaultValue) {
	let value = null;

	try {
		value = localStorage.getItem(namespace + name);
	} catch (ex) {
		logger.warn('LocalStorage not supported');
	}

	if (!value && defaultValue) {
		value = defaultValue;
	}

	return value;
}

function setSetting(name, value) {
	try {
		return localStorage.setItem(namespace + name, value);
	} catch (ex) {
		logger.warn('LocalStorage not supported');

		return false;
	}
}

export { getSetting, setSetting };
